/**
 * "A new version is waiting" as observable state.
 *
 * Deliberately a tiny store rather than a DOM insertion. The standing rule is that all
 * UI derives from state and nothing imperatively patches siblings -- a banner appended
 * from a service-worker callback is exactly the kind of out-of-band mutation that later
 * disagrees with what React thinks is on screen.
 */

type Listener = (pending: boolean) => void;

let pending = false;
const listeners = new Set<Listener>();

export function updatePending(): boolean {
  return pending;
}

export function markUpdatePending(): void {
  if (pending) return;
  pending = true;
  for (const listener of listeners) listener(true);
}

export function subscribeUpdatePending(listener: Listener): () => void {
  listeners.add(listener);
  listener(pending);
  return () => {
    listeners.delete(listener);
  };
}

/** Tests only: the store outlives a component, so it has to be resettable. */
export function resetUpdatePending(): void {
  pending = false;
  listeners.clear();
}
